// src/pages/WorkerResetPassword.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FiEye, FiEyeOff } from "react-icons/fi";
import bynLogo from "./byn-logo.jpeg";

const API_WRK = process.env.REACT_APP_API_WRK;

const WorkerResetPassword = () => {
  const navigate = useNavigate();
  const email = localStorage.getItem("workerResetEmail");

  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!email) navigate("/worker-forgot-password");
  }, [email, navigate]);

  const handleReset = async (e) => {
    e.preventDefault();
    setMessage("");

    if (!otp || !newPassword || !confirm) {
      setMessage("All fields are required.");
      return;
    }

    if (newPassword !== confirm) {
      setMessage("Passwords do not match.");
      return;
    }

    try {
      await axios.post(`${API_WRK}/reset-password`, {
        email,
        otp,
        newPassword,
      });

      localStorage.removeItem("workerResetEmail");
      setMessage("Password updated. Redirecting...");
      setTimeout(() => navigate("/worker-login"), 900);
    } catch (err) {
      setMessage(err.response?.data?.message || "Reset failed.");
    }
  };

  return (
    <div className="min-h-screen bg-white px-6 py-12">
      <div className="max-w-md mx-auto space-y-6">

        {/* 🔥 BYN LOGO */}
        <div className="flex justify-center">
          <img
            src={bynLogo}
            alt="Book Your Need"
            className="w-44 h-44 object-contain"
          />
        </div>

        <form onSubmit={handleReset} className="space-y-4">
          <input
            placeholder="6-digit code"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            className="w-full px-4 py-3 rounded-full border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500"
          />

          <div className="relative">
            <input
              type={show1 ? "text" : "password"}
              placeholder="New password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="w-full px-4 py-3 rounded-full border border-gray-200 pr-10 focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
            <span
              onClick={() => setShow1(!show1)}
              className="absolute right-4 top-1/2 -translate-y-1/2 cursor-pointer text-gray-400"
            >
              {show1 ? <FiEyeOff /> : <FiEye />}
            </span>
          </div>

          <div className="relative">
            <input
              type={show2 ? "text" : "password"}
              placeholder="Confirm password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              className="w-full px-4 py-3 rounded-full border border-gray-200 pr-10 focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
            <span
              onClick={() => setShow2(!show2)}
              className="absolute right-4 top-1/2 -translate-y-1/2 cursor-pointer text-gray-400"
            >
              {show2 ? <FiEyeOff /> : <FiEye />}
            </span>
          </div>

          <button
            type="submit"
            className="w-full py-3 rounded-full font-semibold text-white bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 hover:opacity-90 active:scale-95 transition"
          >
            Update password
          </button>
        </form>

        {message && (
          <p className="text-sm text-red-500 text-center">{message}</p>
        )}
      </div>
    </div>
  );
};

export default WorkerResetPassword;
